module.exports = __webpack_public_path__ + "media/images/icons/ic-check-small-3340ad910217812823696fb24489ee44.svg";